import * as Auth from "./Auth";
import CalendarAPI from "./Calendar";

const Google = {
    Auth,
    CalendarAPI,
};

export default Google;
